<div class="list-item">
  <app-skeleton-loader [Cwidth]="'250'" [Cheight]="'84'" ></app-skeleton-loader>
</div>
<div class="list-item">
  <app-skeleton-loader [Cwidth]="'250'" [Cheight]="'84'" ></app-skeleton-loader>
</div>
<div class="list-item">
  <app-skeleton-loader [Cwidth]="'250'" [Cheight]="'84'" ></app-skeleton-loader>
</div>
<div class="list-item">
  <app-skeleton-loader [Cwidth]="'250'" [Cheight]="'84'" ></app-skeleton-loader>
</div>
<div class="list-item">
  <app-skeleton-loader [Cwidth]="'250'" [Cheight]="'84'" ></app-skeleton-loader>
</div>
<div class="list-item">
  <app-skeleton-loader [Cwidth]="'250'" [Cheight]="'84'" ></app-skeleton-loader>
</div>
<div class="list-item">
  <app-skeleton-loader [Cwidth]="'250'" [Cheight]="'84'" ></app-skeleton-loader>
</div>
